import { lazy } from 'react';
import LamanteShell from 'src/components/site/shells/LamanteShell';
import {
    ROUTE_COFFEEHOUSE_RIGA,
    ROUTE_COFFEEHOUSE_RIGA_50,
    ROUTE_COFFEEHOUSE_RIGA_50_VOUCHER_CONFIRMED,
    ROUTE_COFFEEHOUSE_VOUCHER_CONFIRMED,
} from 'src/config/routes';
import { coreSiteRoutes } from 'src/config/sites/coreRoutes';
import { createModuleInit } from './moduleInit';
import { SiteDefinition } from './SiteDefinition';

const CoffeeHouseRigaRoutes = lazy(() => import('src/pages/coffeeHouseRiga/CoffeeHouseRigaRoutes'));
const CoffeeHouseVoucherConfirmedPage = lazy(() => import('src/pages/coffeeHouseRiga/CoffeeHouseVoucherConfirmedPage'));
const CoffeeHouseRiga50Page = lazy(() => import('src/pages/coffeeHouseRiga/CoffeeHouseRiga50Page'));
const CoffeeHouseRiga50VoucherConfirmedPage = lazy(
    () => import('src/pages/coffeeHouseRiga/CoffeeHouseRiga50VoucherConfirmedPage')
);

const lamanteSite: SiteDefinition = {
    id: 'lamante',
    label: "L'Amante Classic",
    description: 'Primary customer experience with full navigation and business logic.',
    routes: [
        {
            key: 'coffeehouse-riga',
            route: ROUTE_COFFEEHOUSE_RIGA,
            component: CoffeeHouseRigaRoutes,
        },
        {
            key: 'coffeehouse-voucher-confirmed',
            route: ROUTE_COFFEEHOUSE_VOUCHER_CONFIRMED,
            component: CoffeeHouseVoucherConfirmedPage,
        },
        // before riga-50: its non-exact prefix would also match /coffeehouse/riga-50/voucher-confirmed
        {
            key: 'coffeehouse-riga-50-voucher-confirmed',
            route: ROUTE_COFFEEHOUSE_RIGA_50_VOUCHER_CONFIRMED,
            component: CoffeeHouseRiga50VoucherConfirmedPage,
        },
        {
            key: 'coffeehouse-riga-50',
            route: ROUTE_COFFEEHOUSE_RIGA_50,
            component: CoffeeHouseRiga50Page,
        },
        ...coreSiteRoutes,
    ],
    shell: LamanteShell,
    init: createModuleInit(),
};

export default lamanteSite;
